import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { deepEqual } from 'fast-equals';
import { NEVER, zip } from 'rxjs';
import { distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

import { AnalyticsSegmentClient } from './analytics-segment-client';

const findLastActivatedChild = (activatedRoute: ActivatedRoute) => {
  const lookup = (ar: ActivatedRoute): ActivatedRoute | null => {
    if (ar.firstChild) {
      return lookup(ar.firstChild);
    }

    return ar;
  };

  return lookup(activatedRoute);
};

@Injectable()
export class AnalyticsRouteTracker {
  constructor(private injector: Injector) {
    const router = injector.get(Router);
    const client = injector.get(AnalyticsSegmentClient);

    router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        switchMap(() => {
          const route = findLastActivatedChild(injector.get(ActivatedRoute));
          return route ? zip(route.data, route.params) : NEVER;
        }),
        filter(([data]) => !!data.analytics),
        distinctUntilChanged(deepEqual),
      )
      .subscribe(([data, params]) => {
        if (data.analytics.filter) {
          if (!data.analytics?.filter(params)) {
            return;
          }
        }

        client.page(data.analytics.category, data.analytics.name);
      });
  }
}
